import { FaFacebook, FaHome, FaLinkedin, FaMailBulk, FaPhone, FaTwitter } from 'react-icons/fa';
import './Footer.css';

import React from 'react'

const Footer = () => {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='left'>
                    <div className='location'>
                        <FaHome size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                        <div>
                            <p>Sector 99A Gurugram.</p>
                            <p>India.</p>
                        </div>
                    </div>
                    <div className='phone'>
                        <h4>
                            <FaPhone size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                            +91 89572 87715
                        </h4>
                    </div>
                    <div className='email'>
                        <h4>
                            <FaMailBulk size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                            nitikaupadhyay6@gmail.com
                        </h4>
                    </div>
                </div>
                <div className='right'>
                    <h4>Connect with me on Social Media !</h4>

                    <div className='social'>
                    <a href='https://www.linkedin.com/in/nitika-upadhyay/' target='_blank'>
                            <FaLinkedin size={30} style={{ color: "#fff", marginRight: "1rem" }} />
                        </a>
                        <a href='#'>
                            <FaFacebook size={30} style={{ color: "#fff", marginRight: "1rem" }} />
                        </a>
                        <a href='#'>
                            <FaTwitter size={30} style={{ color: "#fff", marginRight: "1rem" }} />
                        </a>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer